export default __webpack_public_path__ + "static/media/money-back@2x.c220ac5d.png";